import ongoing1 from "../../Assests/Bridge_7.jpg";
import ongoing2 from "../../Assests/Bridge_6.jpg";
import ongoing3 from "../../Assests/Bridge_5.jpg";

import completedA1 from "../../assets/Completed_Sl_No_1/1.jpeg";
import completedA2 from "../../assets/Completed_Sl_No_1/2.jpeg";
import completedA3 from "../../assets/Completed_Sl_No_1/3.jpeg";

import completedB1 from "../../assets/Completed_SL_NO_2/1.jpeg";
import completedB2 from "../../assets/Completed_SL_NO_2/2.jpeg";

import completedC1 from "../../assets/Completed_SL_No_3/1.jpeg";
import completedC2 from "../../assets/Completed_SL_No_3/2.jpeg";
import completedC3 from "../../assets/Completed_SL_No_3/3.jpeg";

import completedD1 from "../../assets/Completed_SL_No_4/1.jpeg";
import completedD2 from "../../assets/Completed_SL_No_4/2.jpeg";
import completedD3 from "../../assets/Completed_SL_No_4/3.jpeg";
import completedD4 from "../../assets/Completed_SL_No_4/4.jpeg";

import completedE1 from "../../assets/Completed_SL_No_5/1.jpeg";
import completedE2 from "../../assets/Completed_SL_No_5/2.jpeg";
import completedE3 from "../../assets/Completed_SL_No_5/3.jpeg";
import completedE4 from "../../assets/Completed_SL_No_5/4.jpeg";

import completedF1 from "../../assets/Completed_SL_No_6/1.jpeg";
import completedF2 from "../../assets/Completed_SL_No_6/2.jpeg";
import completedF3 from "../../assets/Completed_SL_No_6/3.jpeg";

import completedG1 from "../../assets/Completed_SL_No_7/1.jpeg";
import completedG2 from "../../assets/Completed_SL_No_7/2.jpeg";
import completedG3 from "../../assets/Completed_SL_No_7/3.jpeg";
import completedG4 from "../../assets/Completed_SL_No_7/4.jpeg";
import completedG5 from "../../assets/Completed_SL_No_7/5.jpeg";
import completedG6 from "../../assets/Completed_SL_No_7/6.jpeg";

import completedH1 from "../../assets/Completed_SL_No_8/1.jpeg";
import completedH2 from "../../assets/Completed_SL_No_8/2.jpeg";

import completedI1 from "../../assets/Logo/logo.svg";
import completedI2 from "../../assets/Logo/logo.svg";

export const projects = {
  ongoing: [
    {
      id: 1,
      title: "Construction of Major Bridge No. 259",
      subtitle: "Multispan Open Web Girder Bridge at Nidhipanda",
      description:
        "This project involves the construction of a single multispan major bridge (Bridge No. 259) with dimensions of 12 spans of 45.7 meters, designed to support a loading capacity of 25 tons. The bridge will utilize an open web girder design, facilitating robust structural integrity while optimizing material usage. Located at Nidhipanda, the bridge plays a crucial role in enhancing rail connectivity between Haldipada and Balasore.",
      image: ongoing1,
      tags: [" South Eastern Railway", "Garden Reach"],
      progress: "18/09",
      year: "2024",
      status: "In Progress",
      subProjects: [
        {
          id: 101,
          title: "Bridge Construction Project Management and Execution",
          description:
            "The management phase of the construction of Major Bridge No. 259 centers on effective project planning, resource allocation, and execution strategies. This includes the coordination of various teams across engineering, logistics, and safety sectors to minimize any disruptions to train services and ensure compliance with South Eastern Railway’s stringent safety standards. The project management team will focus on developing a detailed timeline, overseeing procurement of materials, and conducting regular inspections throughout the construction process.",
          image: ongoing2,
        },
        {
          id: 102,
          title: "Multispan Major Bridge No. 259 Construction",
          description:
            "The construction of Multispan Major Bridge No. 259 involves the installation of a robust 12x45.7m open web girder bridge designed to accommodate 25-ton loading. Located at Nidhipanda on the railway section between Haldipada and Balasore, this project aims to enhance connectivity and support efficient rail transport. The project is developed under the auspices of South Eastern Railway / Garden Reach, ensuring adherence to safety and engineering standards throughout the construction process.",
          image: ongoing3,
        },
        {
          id: 103,
          title: "Construction of Major Bridge No. 259",
          description:
            "This project involves the construction of a single multispan major bridge (Bridge No. 259) with dimensions of 12 spans of 45.7 meters, designed to support a loading capacity of 25 tons. The bridge will utilize an open web girder design, facilitating robust structural integrity while optimizing material usage. Located at Nidhipanda, the bridge plays a crucial role in enhancing rail connectivity between Haldipada and Balasore.",
          image: ongoing1,
        },
      ],
    },

    {
      id: 2,
      title: "Construction of Boundary Wall at Railway Stations JSME and BDME",
      subtitle: "Strengthening Security Measures at JSME and BDME Stations",
      description:
        "This component of the project entails the construction of a boundary wall at the railway stations of JSME and BDME. The primary aim is to enhance safety by preventing unauthorized access to railway premises. The construction will include the necessary excavation and masonry work and the development of approaches that ensure safe and efficient access to the wall for maintenance and emergency services.",
      image: "https://via.placeholder.com/300x200",
      tags: ["Eastern Railway", "Asansol"],
      progress: "01/03",
      year: "2024",
      status: "In Progress",
      subProjects: [
        {
          id: 201,
          title:
            "Construction of Boundary Wall at Railway Stations JSME and BDME",
          description:
            "This component of the project entails the construction of a boundary wall at the railway stations of JSME and BDME. The primary aim is to enhance safety by preventing unauthorized access to railway premises. The construction will include the necessary excavation and masonry work and the development of approaches that ensure safe and efficient access to the wall for maintenance and emergency services.",
          image: "https://via.placeholder.com/300x200",
          progress: "01/03",
        },
        {
          id: 202,
          title: "Boundary Wall Construction at STL and LHB Stations",
          description:
            "This phase focuses on the construction of a boundary wall at the STL and LHB railway stations. The initiative aims to bolster security and safety by creating a physical barrier against unauthorized intrusion. The project will involve careful planning of excavation and masonry processes, along with the establishment of access roads leading to the boundary wall. Compliance with railway safety standards is critical to this project, ensuring that train operations remain unaffected while maintaining accessibility for emergency response teams. Selection of high-quality materials will emphasize longevity and resilience against environmental factors.",
          image: "https://via.placeholder.com/300x200",
          progress: "02/03",
        },
        {
          id: 203,
          title:
            "Comprehensive Project Plan for Boundary Wall Construction Detailed Strategy for Enhanced Railway Security Across JSME, BDME, STL, and LHB",
          description:
            "This overarching project plan outlines the strategic approach for constructing boundary walls and approach roads at stations JSME, BDME, STL, and LHB. The plan addresses key aspects such as compliance with railway safety regulations, minimizing operational disruptions, and ensuring efficient access for emergency services. Logistics and timelines will be meticulously detailed to facilitate a smooth construction process.",
          image: "https://via.placeholder.com/300x200",
          progress: "03/03",
        },
      ],
    },

    {
      id: 3,
      title: "Protection Work Project from Rasulpur to Saktigarh",
      subtitle:
        "RCC, Brick Work, and Ancillary Works for Infrastructure Stability",
      description:
        "This project aims to enhance the structural integrity and safety of the area between Rasulpur (including the yard) and Saktigarh. The scope of work includes specialized protection measures, reinforced cement concrete (RCC) construction, brick work, and other ancillary services required to ensure durability and resilience against environmental challenges. By executing these crucial infrastructure improvements, we anticipate fostering better transportation, reducing erosion, and guaranteeing the longevity of existing structures.",
      image: "https://via.placeholder.com/300x200",
      tags: ["Eastern Railway", "HQ"],
      progress: "01/03",
      year: "2024",
      status: "In Progress",
      subProjects: [
        {
          id: 301,
          title: "Protection Work Project from Rasulpur to Saktigarh",
          description:
            "This project aims to enhance the structural integrity and safety of the area between Rasulpur (including the yard) and Saktigarh. The scope of work includes specialized protection measures, reinforced cement concrete (RCC) construction, brick work, and other ancillary services required to ensure durability and resilience against environmental challenges. By executing these crucial infrastructure improvements, we anticipate fostering better transportation, reducing erosion, and guaranteeing the longevity of existing structures.",
          image: "https://via.placeholder.com/300x200",
          progress: "01/03",
        },
        {
          id: 302,
          title: "RCC Structures Construction",
          description:
            "It focuses on the construction of reinforced cement concrete (RCC) structures along the Rasulpur to Saktigarh route. The RCC works will include foundational support, retaining walls, and structural reinforcements designed to withstand environmental stresses and enhance long-term stability. The goal is to provide a solid foundation for various upcoming infrastructural developments in the area.",
          image: "https://via.placeholder.com/300x200",
          progress: "02/03",
        },
        {
          id: 303,
          title: "Brick Work and Ancillary Activities",
          description:
            "This subproject involves comprehensive brick work essential for the overall infrastructure enhancement between Rasulpur and Saktigarh. This includes the construction of walls, pavements, and landscaping features using durable brick materials. Ancillary activities will encompass site preparation, drainage systems, and other essential utilities to support the newly built structures and ensure their functionality within the community.",
          image: "https://via.placeholder.com/300x200",
          progress: "03/03",
        },
      ],
    },

    {
      id: 4,
      title:
        "Construction of New Broad Gauge Rail Line from Tarakeswar to Bishnupur",
      subtitle:
        "Comprehensive Infrastructure Development for Enhanced Rail Connectivity",
      description:
        "This project involves the construction of a new Broad Gauge (B.G.) railway line connecting Tarakeswar to Bishnupur. The scope of work includes significant earthwork in filling for the railway embankment, blanketing over the formation, and turfing to ensure durability and safety. The construction will also encompass retaining walls, major and minor bridges, Railway Under Bridges (RUBs), drainage systems, and approach roads. Additionally, the project will feature the development of station platforms and buildings at Baragopinathpur, Jayrambati, and Kamarpukur stations, along with the linking of permanent way (P.W.) tracks between Maynapur and Goghat.",
      image: "https://via.placeholder.com/300x200",
      tags: ["Eastern Railway", "HQ"],
      progress: "01/03",
      year: "2024",
      status: "In Progress",
      subProjects: [
        {
          id: 401,
          title:
            "Construction of New Broad Gauge Rail Line from Tarakeswar to Bishnupur",
          description:
            "This project involves the construction of a new Broad Gauge (B.G.) railway line connecting Tarakeswar to Bishnupur. The scope of work includes significant earthwork in filling for the railway embankment, blanketing over the formation, and turfing to ensure durability and safety. The construction will also encompass retaining walls, major and minor bridges, Railway Under Bridges (RUBs), drainage systems, and approach roads. Additionally, the project will feature the development of station platforms and buildings at Baragopinathpur, Jayrambati, and Kamarpukur stations, along with the linking of permanent way (P.W.) tracks between Maynapur and Goghat.",
          image: "https://via.placeholder.com/300x200",
          progress: "01/03",
        },
        {
          id: 402,
          title: "Earthwork and Embankment Construction",
          description:
            "It focuses on the earthwork required for filling and forming the railway embankment. This involves excavation, transportation, and placement of materials to create a stable and durable base for the railway tracks. Emphasis will be placed on soil compaction and proper drainage to enhance the longevity of the embankment structure.",
          image: "https://via.placeholder.com/300x200",
          progress: "3/4",
        },
        {
          id: 403,
          title: "Station Development and Platform Construction",
          description:
            "It encompasses the complete development of railway stations at Baragopinathpur, Jayrambati, and Kamarpukur. It includes the construction of station platforms, waiting areas, ticket counters, and station buildings. The design aims to facilitate efficient passenger movement and provide necessary amenities, thereby improving overall user experience at these stations.",
          image: "https://via.placeholder.com/300x200",
          progress: "2/5",
        },
      ],
    },
  ],
  completed: [
    {
      id: 1,
      title: "Infrastructure Development at Sikaripara Station",
      subtitle:
        "Enhancing Transportation Facilities through Comprehensive Construction Projects",
      description:
        "The infrastructure development project at Sikaripara Station focuses on the construction of essential facilities including a new platform, an upgraded station building, and a secure boundary wall. These enhancements aim to improve passenger experience, ensure safety, and boost accessibility for the local community. Through these developments, Sikaripara Station will be better equipped to handle increasing passenger flow and provide a welcoming environment for travelers.",
      image: completedA1,
      tags: ["Eastern Railway", "Asansol", "SikariparaStation"],
      progress: "01/03",
      year: "2016",
      status: "Completed",
      subProjects: [
        {
          id: 101,
          title: "Infrastructure Development at Sikaripara Station",
          description:
            "The infrastructure development project at Sikaripara Station focuses on the construction of essential facilities including a new platform, an upgraded station building, and a secure boundary wall. These enhancements aim to improve passenger experience, ensure safety, and boost accessibility for the local community. Through these developments, Sikaripara Station will be better equipped to handle increasing passenger flow and provide a welcoming environment for travelers.",
          image: completedA1,
          progress: "01/03",
        },
        {
          id: 102,
          title: "Construction of New Platform",
          description:
            "This subproject involves the design and construction of a new, state-of-the-art platform at Sikaripara Station. The platform will be constructed with modern materials to ensure durability and safety for passengers. Features will include benches, lighting, and signage to assist passengers in navigating the station with ease.",
          image: completedA2,
          progress: "02/03",
        },
        {
          id: 103,
          title: "Station Building Renovation",
          description:
            "The station building renovation focuses on upgrading the existing facilities to provide a more comfortable and efficient environment for passengers. Improvements will include larger waiting areas, restrooms, ticket counters, and amenities such as food stalls and retail shops, ensuring that travelers have access to necessary services while waiting for their trains.",
          image: completedA3,
          progress: "03/03",
        },
      ],
    },

    {
      id: 2,
      title:
        "Construction of Station Building and Boundary Wall at Barapalasi Station",
      subtitle:
        "Enhancing Infrastructure for Improved Passenger Experience and Safety",
      description:
        "The project focuses on the construction of a modern station building and a robust boundary wall at Barapalasi Station. This initiative aims to enhance the overall infrastructure, ensuring better facilities for passengers and providing security and safety for the station premises. The new station building will feature improved amenities, waiting areas, and ticketing services, while the boundary wall will safeguard the station's assets and prevent unauthorized access.",
      image: completedB1,
      tags: ["Eastern Railway", "Asansol", "Safety"],
      progress: "30/10",
      year: "2016",
      status: "Completed",
      subProjects: [
        {
          id: 201,
          title:
            "Construction of Station Building and Boundary Wall at Barapalasi Station",
          description:
            "The project focuses on the construction of a modern station building and a robust boundary wall at Barapalasi Station. This initiative aims to enhance the overall infrastructure, ensuring better facilities for passengers and providing security and safety for the station premises. The new station building will feature improved amenities, waiting areas, and ticketing services, while the boundary wall will safeguard the station's assets and prevent unauthorized access.",
          image: completedB1,
          progress: "01/02",
        },
        {
          id: 202,
          title: "Landscaping and Surrounding Infrastructure",
          description:
            "It includes the landscaping of the surrounding area of Barapalasi Station to improve aesthetics and functionality. It will feature greenspaces, parking areas, and pathways for easy access to the station. The aim is to create a welcoming environment for passengers and visitors alike.",
          image: completedB2,
          progress: "01/02",
        },
      ],
    },

    {
      id: 3,
      title: "Andul-Baltikuri Doubling Project",
      subtitle:
        "Earthwork, Major and Minor Bridges, Retaining Walls, and Station Building Construction",
      description:
        "The Andul-Baltikuri Doubling Project involves comprehensive civil engineering works over a stretch of 1.4 kilometers. This project focuses on the execution of essential earthworks, construction of a major bridge with a span of three 30.48-meter sections, minor bridges, retention walls, and the development of station buildings. These infrastructure improvements are designed to enhance the efficiency and capacity of the railway line, accommodating increased train frequency and ensuring passenger safety and comfort.",
      image: completedC1,
      tags: ["South Eastern Railway", "Garden Reach", "Railway Infrastructure"],
      progress: "01/03",
      year: "2018",
      status: "Completed",
      subProjects: [
        {
          id: 301,
          title: "Andul-Baltikuri Doubling Project",
          description:
            "The Andul-Baltikuri Doubling Project involves comprehensive civil engineering works over a stretch of 1.4 kilometers. This project focuses on the execution of essential earthworks, construction of a major bridge with a span of three 30.48-meter sections, minor bridges, retention walls, and the development of station buildings. These infrastructure improvements are designed to enhance the efficiency and capacity of the railway line, accommodating increased train frequency and ensuring passenger safety and comfort.",
          image: completedC1,
          progress: "01/03",
        },
        {
          id: 302,
          title: "Major Bridge Construction",
          description:
            "The major bridge construction encompasses a span of three sections, each measuring 30.48 meters. This structure is a critical component of the Andul-Baltikuri Doubling Project, providing essential support for the increased load and improving overall railway safety and functionality. The bridge will feature advanced engineering techniques to ensure durability and reliability in challenging weather conditions.",
          image: completedC2,
          progress: "02/03",
        },
        {
          id: 303,
          title: "Minor Bridges Development",
          description:
            "It involves the construction of several minor bridges that will facilitate drainage and ensure the seamless flow of rail traffic. Each bridge is designed to integrate with the surrounding landscape while fulfilling necessary structural and environmental standards. The minor bridges play a vital role in maintaining track integrity and preventing flooding in adjacent areas.",
          image: completedC3,
          progress: "03/03",
        },
      ],
    },

    {
      id: 4,
      title:
        "Rehabilitation Work for Doubling of Andul - Baltikuri Section at Mourigram - Bankra Nayabaz Station",
      subtitle:
        "Enhancing Rail Infrastructure to Improve Capacity and Reliability",
      description:
        "This project focuses on the rehabilitation work at Mourigram - Bankra Nayabaz Station as part of the overarching initiative to double the Andul - Baltikuri railway section. The objective is to upgrade the existing infrastructure to accommodate increased train traffic, enhance operational safety, and improve passenger services. This project will utilize modern techniques and materials to ensure longevity and sustainability, thereby contributing to the efficiency of the railway network in the region.",
      image: completedD1,
      tags: [
        "South Eastern Railway",
        "Garden Reach",
        "Infrastructure Development",
      ],
      progress: "01/04",
      year: "2019",
      status: "Completed",
      subProjects: [
        {
          id: 401,
          title:
            "Rehabilitation Work for Doubling of Andul - Baltikuri Section at Mourigram - Bankra Nayabaz Station",
          description:
            "This project focuses on the rehabilitation work at Mourigram - Bankra Nayabaz Station as part of the overarching initiative to double the Andul - Baltikuri railway section. The objective is to upgrade the existing infrastructure to accommodate increased train traffic, enhance operational safety, and improve passenger services. This project will utilize modern techniques and materials to ensure longevity and sustainability, thereby contributing to the efficiency of the railway network in the region.",
          image: completedD1,
          progress: "01/04",
        },
        {
          id: 402,
          title: "Track Realignment and Strengthening",
          description:
            "It involves the realignment of existing tracks to improve the geometry and strengthen the trackbed to handle heavier loads and increased traffic. It includes replacing outdated ballast and ties, installing modern signaling systems, and ensuring compliance with safety standards.",
          image: completedD2,
          progress: "4/4",
        },
        {
          id: 403,
          title: "Platform and Station Facilities Enhancement",
          description:
            "Enhancing the platforms and station facilities to provide better services to passengers is a key focus. This includes widening platforms, adding shelter, improving accessibility features, and upgrading lighting and signage to ensure a safe and comfortable experience for travelers.",
          image: completedD3,
          progress: "5/5",
        },
        {
          id: 404,
          title: "Drainage and Environmental Management",
          description:
            "To enhance the drainage systems around the station to prevent flooding and manage stormwater effectively. It includes the installation of sustainable drainage solutions and measures to mitigate environmental impact during and after construction, promoting ecological balance in the region.",
          image: completedD4,
          progress: "5/5",
        },
      ],
    },

    {
      id: 5,
      title: "Construction of Road Over Bridge at Nilgiri-Balasore",
      subtitle: "Major Infrastructure Development on Kharagpur-Bhadrak Section",
      description:
        "The project involves the execution of a road over bridge (ROB) comprising spans of 24.00 meters, 36.00 meters, and 18.00 meters, strategically located between Nilgiri and Balasore on the Kharagpur-Bhadrak railway section. This infrastructure is designed to enhance transportation efficiency, reduce traffic congestion, and improve safety for both vehicular and pedestrian traffic in the region. The ROB will serve as a crucial link, facilitating the smooth flow of goods and passengers while ensuring uninterrupted rail services.",
      image: completedE1,
      tags: ["South Eastern Railway", "Garden Reach", "Road Over Bridge"],
      progress: "01/04",
      year: "2021",
      status: "Completed",
      subProjects: [
        {
          id: 501,
          title: "Construction of Road Over Bridge at Nilgiri-Balasore",
          description:
            "The project involves the execution of a road over bridge (ROB) comprising spans of 24.00 meters, 36.00 meters, and 18.00 meters, strategically located between Nilgiri and Balasore on the Kharagpur-Bhadrak railway section. This infrastructure is designed to enhance transportation efficiency, reduce traffic congestion, and improve safety for both vehicular and pedestrian traffic in the region. The ROB will serve as a crucial link, facilitating the smooth flow of goods and passengers while ensuring uninterrupted rail services.",
          image: completedE1,
          progress: "01/04",
        },
        {
          id: 502,
          title: "Engineering and Design of Road Over Bridge",
          description:
            "It focuses on the comprehensive engineering design and planning of the road over bridge, ensuring it meets safety standards and structural integrity requirements. All design elements will consider load capacities, environmental impacts, and local regulations to create an efficient and reliable bridge.",
          image: completedE2,
          progress: "02/04",
        },
        {
          id: 503,
          title: "Construction and Material Procurement for ROB",
          description:
            "The construction phase of the project entails the procurement of high-quality materials, equipment, and skilled labor necessary for the effective execution of the road over bridge. This sub-project will detail the processes of site preparation, foundation work, span construction, and final finishing processes, ensuring adherence to timelines and budget constraints.",
          image: completedE3,
          progress: "03/04",
        },
        {
          id: 504,
          title: "Safety and Quality Assurance in ROB Development",
          description:
            "It emphasizes the implementation of rigorous safety protocols and quality assurance measures throughout the construction of the road over bridge. It involves regular inspections, compliance checks, and testing of materials to ensure the structure's longevity and adherence to national safety standards. Training sessions for workers on safety practices will also be conducted to further minimize risks on the construction site.",
          image: completedE4,
          progress: "04/04",
        },
      ],
    },

    {
      id: 6,
      title:
        "Sheet Piling and Ancillary Works for Restoration of 2.5 MGD Water Treatment Plant at Howrah",
      subtitle:
        "Enhancing Water Treatment Infrastructure through Effective Sheet Piling Solutions",
      description:
        "This project involves the implementation of sheet piling and associated ancillary works necessary for the restoration of a 2.5 Million Gallons per Day (MGD) water treatment plant located in Howrah. The primary goal is to support the structural integrity of the plant, enhance its operational capacity, and ensure compliance with environmental and safety standards. The project will focus on the installation of sheet piles to create a reliable barrier against water ingress, protect existing structures, and facilitate necessary rehabilitation works.",
      image: completedF1,
      tags: [
        "Eastern Railway",
        "Howrah",
        "Restoration Work",
        "Sheet Piling",
        "Water Treatment Plant",
      ],
      progress: "01/03",
      year: "2021",
      status: "Completed",
      subProjects: [
        {
          id: 601,
          title:
            "Sheet Piling and Ancillary Works for Restoration of 2.5 MGD Water Treatment Plant at Howrah",
          description:
            "This project involves the implementation of sheet piling and associated ancillary works necessary for the restoration of a 2.5 Million Gallons per Day (MGD) water treatment plant located in Howrah. The primary goal is to support the structural integrity of the plant, enhance its operational capacity, and ensure compliance with environmental and safety standards. The project will focus on the installation of sheet piles to create a reliable barrier against water ingress, protect existing structures, and facilitate necessary rehabilitation works.",
          image: completedF1,
          progress: "01/03",
        },
        {
          id: 602,
          title: "Site Preparation and Assessment",
          description:
            "It involves comprehensive site preparation and assessment activities prior to the commencement of sheet piling operations. It includes surveying the site, identifying existing utilities, and conducting geotechnical investigations to ensure the suitability of the location for piling. Necessary permits and environmental assessments will also be obtained during this phase.",
          image: completedF2,
          progress: "02/03",
        },
        {
          id: 603,
          title: "Sheet Piling Installation",
          description:
            "The main focus of this subproject is the installation of sheet piles around the water treatment facility. This includes the selection of appropriate materials, transportation to the site, and the application of advanced techniques for driving the piles into the ground. The objective is to create a secure barrier that will prevent water intrusion and provide support for the restoration efforts.",
          image: completedF3,
          progress: "03/03",
        },
      ],
    },

    {
      id: 7,
      title:
        "Execution of Bowstring Girder Road Over Bridge on Balasore - Nilgiri Road",
      subtitle:
        "Bridging Connectivity on the Kharagpur - Bhadrak Railway Section",
      description:
        "This project involves the construction of a state-of-the-art Road Over Bridge (ROB) featuring a Bowstring Girder design with a span of 48.0 meters. Located strategically between Balasore and Nilgiri along the Kharagpur - Bhadrak railway section, this infrastructure aims to enhance transportation efficiency, reduce traffic congestion, and ensure safer crossings for vehicles and pedestrians. The new ROB is expected to significantly improve connectivity in the region, facilitating better access and promoting economic growth.",
      image: completedG1,
      tags: ["South Eastern Railway", "Garden Reach", "Nilgiri"],
      progress: "01/06",
      year: "2021",
      status: "Completed",
      subProjects: [
        {
          id: 701,
          title:
            "Execution of Bowstring Girder Road Over Bridge on Balasore - Nilgiri Road",
          description:
            "This project involves the construction of a state-of-the-art Road Over Bridge (ROB) featuring a Bowstring Girder design with a span of 48.0 meters. Located strategically between Balasore and Nilgiri along the Kharagpur - Bhadrak railway section, this infrastructure aims to enhance transportation efficiency, reduce traffic congestion, and ensure safer crossings for vehicles and pedestrians. The new ROB is expected to significantly improve connectivity in the region, facilitating better access and promoting economic growth.",
          image: completedG1,
          progress: "01/06",
        },
        {
          id: 702,
          title: "Site Preparation and Foundation Work",
          description:
            "It focuses on the initial groundwork necessary for the ROB, including land clearing, excavation, and the setup of foundations to support the Bowstring Girder. Proper soil testing and stabilization will be conducted to ensure long-term durability and safety.",
          image: completedG2,
          progress: "02/06",
        },
        {
          id: 703,
          title: "Fabrication of Bowstring Girder",
          description:
            "Dedicated to the engineering and fabrication of the Bowstring Girder, this subproject includes the design specifications, material selection, and manufacturing processes. Quality control measures will be implemented to guarantee that the girders meet all structural integrity standards.",
          image: completedG3,
          progress: "03/06",
        },
        {
          id: 704,
          title: "Erection of the Bridge Structure",
          description:
            "This phase involves the transportation and installation of the Bowstring Girder onto the pre-built foundations. This subproject encompasses the use of cranes, safety protocols, and alignment checks to ensure the precise placement of the girder.",
          image: completedG4,
          progress: "04/06",
        },
        {
          id: 705,
          title: "Deck Construction and Roadway Integration",
          description:
            "Following the erection of the girder, this subproject will focus on constructing the bridge deck and integrating it with the existing roadways. It includes laying down the surface materials, drainage systems, and completing necessary road signage and markings.",
          image: completedG5,
          progress: "05/06",
        },
        {
          id: 706,
          title: "Safety Features and Environmental Management",
          description:
            "It is dedicated to implementing safety features such as guardrails, warning signals, and pedestrian crossings, ensuring the well-being of users. Additionally, it encompasses environmental management practices to mitigate the project's impact on the surrounding ecosystem during and after construction.",
          image: completedG6,
          progress: "06/06",
        },
      ],
    },

    {
      id: 8,
      title:
        "Construction of Major Bridge No. 188A: Substructure and Girder Erection",
      subtitle: "Composite Girder Bridge Between Rasulpur and Shaktigarh",
      description:
        "This project involves the construction of the substructure and the erection of composite girders for Major Bridge No. 188A, featuring 11 spans, each with a clear span of 18.3 meters. The bridge will serve as a vital connection between Rasulpur and Shaktigarh, enhancing transportation and infrastructure in the area. The project emphasizes durable construction techniques and adherence to safety standards to facilitate long-term usage and reliability.",
      image: completedH1,
      tags: ["Eastern Railway", "HQ"],
      progress: "01/02",
      year: "2022",
      status: "Completed",
      subProjects: [
        {
          id: 801,
          title:
            "Construction of Major Bridge No. 188A: Substructure and Girder Erection",
          description:
            "This project involves the construction of the substructure and the erection of composite girders for Major Bridge No. 188A, featuring 11 spans, each with a clear span of 18.3 meters. The bridge will serve as a vital connection between Rasulpur and Shaktigarh, enhancing transportation and infrastructure in the area. The project emphasizes durable construction techniques and adherence to safety standards to facilitate long-term usage and reliability.",
          image: completedH1,
          progress: "01/02",
        },
        {
          id: 802,
          title: "Substructure Construction for Major Bridge No. 188A",
          description:
            "It focuses on the construction of the bridge's substructure, including footings, piers, and abutments, ensuring a stable foundation for the composite girders. The work will comply with engineering standards and environmental regulations to support the bridge's structural integrity and longevity.",
          image: completedH2,
          progress: "02/02",
        },
      ],
    },

    {
      id: 9,
      title: "Construction of Open Web Through Girder at Kamarkundu Station",
      subtitle: "Replacement of Existing Bridges No. 26 and 26A",
      description:
        "This project involves the construction of an open web through girder bridge with a span of 45.70 meters at Kamarkundu Station. The project necessitates the dismantling of the existing Bridge No. 26 (steel girder) and Bridge No. 26A (RCC box bridge) to facilitate the new construction. The new bridge will enhance the railway's operational efficiency and improve safety for train operations in the area.",
      image: completedI1,
      tags: ["Eastern Railway", "HQ"],
      progress: "01/02",
      year: "2022",
      status: "Completed",
      subProjects: [
        {
          id: 901,
          title:
            "Construction of Open Web Through Girder at Kamarkundu Station",
          description:
            "This project involves the construction of an open web through girder bridge with a span of 45.70 meters at Kamarkundu Station. The project necessitates the dismantling of the existing Bridge No. 26 (steel girder) and Bridge No. 26A (RCC box bridge) to facilitate the new construction. The new bridge will enhance the railway's operational efficiency and improve safety for train operations in the area.",
          image: completedI1,
          progress: "01/02",
        },
        {
          id: 902,
          title: "Dismantling of Existing Bridges No. 26 and 26A",
          description:
            "It focuses on the careful dismantling of the existing Bridge No. 26 (steel girder) and Bridge No. 26A (RCC box bridge) at Kamarkundu Station. The dismantling process will be carried out using advanced techniques to ensure safety and minimize disruption to the surrounding infrastructure. Proper environmental and safety protocols will be adhered to throughout the dismantling process, preparing the site for the construction of the new open web through girder bridge.",
          image: completedI2,
          progress: "02/02",
        },
      ],
    },
  ],
};
